import React, { useEffect, useState } from "react";
import { DownloadModel } from "../Download/DownloadModel";
import Download from "../Download/Download";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";

import "./DownloadsTable.css";

const DownloadsTable: React.FC<{ downloads: Array<DownloadModel> }> = ({
  downloads,
}) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div className="table">
      <div
        className="row header"
        style={{ backgroundColor: theme?.tableHeaderColor }}
      >
        <div className="cell col-md-3">NAME</div>
        <div className="cell release-date">RELEASE DATE</div>
        <div className="cell">VERSION</div>
        <div className="cell">SUPPORTED OS</div>
        <div className="cell">RELEASE NOTES</div>
        <div className="cell">INSTALLER</div>
        <div className="cell">UNINSTALLER</div>
        <div className="cell">USER GUIDE</div>
      </div>
      {downloads && downloads.length > 0 ? (
        downloads.map((content, rowIndex) => (
          <Download
            blok={content}
            key={content._uid}
            rowIndex={rowIndex}
          ></Download>
        ))
      ) : (
        <div className="row">
          <div className="cell">No Data To Display</div>
        </div>
      )}
    </div>
  );
};

export default DownloadsTable;
